import Helpers from '@helpers';
import * as React from 'react';
import { initProfile } from './profile';
import { initToggler } from './toggler';
import { initTitle } from './titleLoader';

class MyProfileController extends React.Component {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        initProfile();
        initToggler();
        initTitle();
        
    }

    public render() {
        return null;
    }
}

Helpers.ReactHelper.createReactElement('MyProfileController', MyProfileController);
